import {
  CONFIRM_COLOR,
  CONFIRM_ICONS,
  TYPE_MODAL
} from '../modal-confirm-notification';

export const CANCEL_SKU_ORDER_PICKING_NOTIFICATION = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title:
    '<center>La totalidad de pedido(s) seleccionados pasarán a estado "Pre-cancelado" ¿Desea continuar?</center>',
  valueButton: 'Continuar',
  valueCancelButton: 'Volver',
  color: CONFIRM_COLOR.PRIMARY,
  iconSVG: CONFIRM_ICONS.WARNING
};
